import { FC } from 'react'

import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { login } from 'src/Router/routes'
import { Desktop, Mobile } from 'src/Components/Responsive'
import { useQuickLoginUTMParameters } from 'src/Hooks/useQuickLoginUTMParameters'
import { signupErrorToLogin } from 'src/Helpers/TagManager/AuthEvents'
import { variables } from 'src/Styled/variables'

interface EmailExistProps {
  emailExist: boolean
}

export const ExistingEmailBlock = styled.p`
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  margin-top: 0px;
  text-align: left;
`

export const ExistingEmailText = styled.span`
  color: ${({ theme }) => theme.color.mediumRed};
  text-align: left;
`

export const RegisterLogin = styled.span`
  color: ${({ theme }) => theme.color.brandGreen};
  border-bottom: 1px dotted ${({ theme }) => theme.color.brandGreen};
  line-height: 21px;
`

export const EmailExist: FC<EmailExistProps> = ({ emailExist }) => {
  const utmParameters = useQuickLoginUTMParameters()
  const params = new URLSearchParams(utmParameters).toString()
  const loginWithParams = `${login}?${params}`

  if (!emailExist) {
    return null
  }
  return (
    <ExistingEmailBlock>
      <ExistingEmailText>Use another email to register or</ExistingEmailText>
      &nbsp;
      <Link onClick={signupErrorToLogin} to={loginWithParams}>
        <Desktop>
          <RegisterLogin>login with your account.</RegisterLogin>
        </Desktop>
        <Mobile>
          <RegisterLogin>login</RegisterLogin>
        </Mobile>
      </Link>
    </ExistingEmailBlock>
  )
}
